import React from 'react'
import dayjs from 'dayjs'
import { MarkedDates } from 'react-native-calendars/src/types'
import { ModeCalendrier } from '../CalendrierUniversel.types'
export default function MonthDateHeader({date, mode, maxDate, markedDates, className}: MonthDateHeaderProps) {
  const dateKey = dayjs(date).format('YYYY-MM-DD')
  const style: React.CSSProperties = {
    width: '100%',
    height: '100%',
    textAlign: 'left',
  }
  if (mode === "month") {
    const marked = markedDates?.[dateKey]
    
    style.color = marked?.disabled || dayjs().isAfter(date, 'day') || (maxDate && dayjs(maxDate).isBefore(date, 'day')) ? '#C4C4C4' : marked?.textColor || 'black'
  }
  return (
    <div className={className} style={style}>
      {dayjs(date).format('D')}
    </div>
  )
}

type MonthDateHeaderProps = {
  date: Date;
  maxDate?: string;
  mode?: ModeCalendrier;
  markedDates?: MarkedDates;
  className?: string;
}